import type { Event } from 'models';
import { usePermissions } from 'permissions';
import { Form, FormActions, Icon, Modal } from 'ui';
import { useInviteMorePeople } from '../../hooks';
import { EventInviteesFilters, type EventInviteesFiltersFormValues } from '../event-invitees-filters';
import { EventInviteesList } from '../event-invitees-list';

type FormValues = EventInviteesFiltersFormValues;

const initialValues: Partial<FormValues> = {
  type: 'individual',
};

type P = {
  event: Event;
  onCancel: () => void;
  onOpenInviteModal?: () => void;
};

const EventInviteesForm = ({ event, onCancel, onOpenInviteModal }: P) => {
  const { distributionList } = event;
  const { canInviteUserToEvent } = usePermissions();
  const hasDistributionList = distributionList ? distributionList.length > 0 : false;
  const [form] = Form.useForm<FormValues>();

  const search = Form.useWatch('search', form);
  const type = Form.useWatch('type', form);

  const handleInviteMorePeople = useInviteMorePeople({
    event,
    onInvite() {
      onOpenInviteModal?.();
    },
  });

  return (
    <>
      <Form<FormValues> form={form} initialValues={initialValues} layout="vertical">
        <EventInviteesFilters hasDistributionList={hasDistributionList} type={type} />

        <EventInviteesList
          event={event}
          filter={{
            search,
            type,
          }}
        />
      </Form>
      <Modal.ScrollableContent.Footer>
        <FormActions
          right={{ children: 'Cancel', onClick: onCancel, size: 'medium' }}
          submit={
            canInviteUserToEvent({ event })
              ? {
                  children: 'Add more people',
                  htmlType: 'button',
                  icon: <Icon icon="user-add-line" />,
                  onClick: handleInviteMorePeople,
                  size: 'medium',
                }
              : undefined
          }
        />
      </Modal.ScrollableContent.Footer>
    </>
  );
};

export default EventInviteesForm;
